import styled, { css } from "styled-components";

const OrdersContainer = styled.div`
    margin-bottom: 30px;
    margin-top: 33px;
    @media (min-width: 768px) {
        padding-left: 50px;
    }

    &.order-details-container {
        margin-top: 15px;
    }

    .discount-info {
        .icon {
            top: -1px;
        }

        .content {
            top: -10px;
            right: calc(100% + 10px);
            opacity: 0;
            visibility: hidden;
            transition: .2s;
            >.inner {
                border: 1px solid #333;
                padding: 10px;
                width: 150px;
                background: #fff;
                border-radius: 6px;
                font-size: 13px;
            }
        }

        &:hover {
            .content {
                z-index: 99;
                opacity: 1;
                visibility: visible;
            }
        }
    }

    .order-details-page-main {
        .back-icon {
            color: #333;
            &:hover {
                color: #000;
            }
        }

        .order-id {
            font-size: 35px;
            color: #333;
            .fulfilment-status {
                border: 1px solid #333;
                padding: 5px 10px 4px;
                // background: #efefef;
            }
        }

        .ordered-items-table {
            th,td {
                border: none;
                padding: 10px;
            }
            th {
                text-transform: capitalize;
            }
            thead {
                border-bottom: 2px solid #ddd;
            }
            tbody {
                border: none;
            }
            tfoot {
                border: none;
                background: #efefef;
                border-bottom: 2px solid #ddd;
                td {
                    padding: 6px 10px;
                }
                > tr:first-child {
                    > td {
                        padding-top 10px;
                    }
                }
                > tr:last-child {
                    > td {
                        padding-bottom 10px;
                    }
                }
            }
        }

        .tabs-view {
            .tabs-head {
                .tab-link {
                    >div {
                        border: 1px solid #ddd;
                        padding: 7px 15px 8px;
                        background: #efefef;
                        min-width: 130px;
                        margin-right: -1px;
                        &:hover {
                            background-color: #fff;
                            color: #000;
                        }
                        &.active {
                            background-color: #fff;
                            font-weight: 600;
                        }
                    }
                }
            }

            .tabs-content {
                border: 1px solid #ddd;
                margin-top: -1px;
                padding: 20px;
                min-height: 200px;
            }
        }
    }

    .order-view {
        .header-view {
            .head {
                font-size: 27px;
                margin-bottom: 2px;
                font-weight: 700;
            }
        }

        .content-view {
            .top-view {
                .search {
                    input {
                        height: 42px;
                        padding-right: 40px;
                        border-radius: 5px;
                    }
                    .icon {
                        top: 9px;
                        right: 10px;
                    }
                    
                    ${(props) =>
                        props.theme &&
                        css`
                            @media (min-width: ${props.theme.breakpoints
                                    .lg_min}px) {
                                input {
                                    width: 400px;
                                }
                            }
                        `}
            }
        }

        .default-form-input {
            box-shadow: none !important;
            border-color: #ddd;
            &:focus {
                border-color: #000;
            }
        }

        table {
            th {
                padding: 10px 14px;
            }
            td {
                padding: 15px 14px;
            }

            .order-id {
                color: #333;
            }

            .actions-td {
                > div {
                    margin-top: 6px;
                    white-space: nowrap;
                }
                .link-container {
                    line-height: 11px;
                    &:not(:last-child) {
                        border-right: 1px solid #333;
                        padding-right: 17px;
                        
                    }
                    .link {
                        &:hover {
                            color: #333;
                        }
                    }
                }
            }
        }

        .orders-list {
            .oi-inner {
                margin-bottom: 15px;
                color: #333;
                transition: 0.2s;
                &:hover {
                    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.1);
                }

                .sec1 {
                    padding: 15px;
                    color: #000;
                    // color: #fff;
                    background: #efefef;
                    border-radius: 5px 5px 0 0;
                }

                .order-id,
                .order-date {
                    // color: #fff;
                    color: #000;
                }

                .sec2 {
                    padding: 15px;
                    border: 1px solid #efefef;
                    border-top: none;
                    border-radius: 0 0 5px 5px;
                }
            }
        }

        .prod-details {
            > .details-item {
                &:not(:last-child) {
                    margin-bottom: 10px;
                }
            }
        }
    }
    
`;

export { OrdersContainer };
